import * as React from "react"
import { useState } from "react"
import { Link, navigate } from "gatsby"
import firebase from "gatsby-plugin-firebase"
import MuiAlert from '@material-ui/lab/Alert';

import { TextField, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, CircularProgress, Snackbar } from "@material-ui/core"

import Header from "../components/Header"

import ImgLogo from "../images/logo.png"
import ImgBoatIcon from "../images/boat-icon.svg"
import ImgBoatIconBlue from "../images/boat-icon-blue.svg"
import ImgBg from "../images/bg.png"
import ImgBg2 from "../images/bg-3.png"

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// markup
const IndexPage = () => {
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [alertDialogTitle, setAlertDialogTitle] = useState("");
  const [alertDialogDesc, setAlertDialogDesc] = useState("");
  const [currentTab, setCurrentTab] = useState(0);

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(false);

  let signIn = async () => {
    if (!email || !password) {
      setValidated(true);
      return;
    }

    setLoading(true);

    try {
      let res = await firebase.auth().signInWithEmailAndPassword(email, password);
      if (res.user)
        navigate("/dashboard", { replace: true });

    } catch (e) {
      console.log(e);
      setSnackbarMessage(e.message);
      setSnackbarOpen(true);
    }
    setLoading(false);
  }

  return (
    <main className="bg-white h-screen" style={{ backgroundColor: "rgb(233,233,233)" }}>


      <div className="flex flex-col md:flex-row md:h-full">
        <div className="w-full md:w-3/5 flex-grow hidden md:flex flex-col justify-start items-center relative">
          <div className="h-24 flex px-6 md:px-10 py-6 items-center bg-transparent absolute top-0 left-0 right-0" >
            <img src={ImgLogo} alt="UWILD logo" className="w-20 h-20 mr-24 cursor-pointer" onClick={() => navigate("/")} />
            <div className="flex-grow"></div>
            <a className="hidden md:block text-gray-500 font-medium text-sm uppercase tracking-wide mx-6 hover:underline" href="/about">About UWILD.com</a>
          </div>

          <div className="flex-grow"></div>

          <h1 className="text-7xl md:px-24 font-medium text-gray-800 mb-6 md:mb-16">
            Advanced Low Footprint Integrity Management Solution.
          </h1>
          <div className="py-8 text-left text-xs font-bold text-gray-400 tracking-wide">
            &copy; {new Date().getFullYear()} UWILD.COM All rights reserved
          </div>
        </div>
        <div className="relative w-full px-16 py-16 md:w-2/5 flex-grow h-screen md:h-auto bg-cover flex flex-col items-start bg-opacity-70" style={{ backgroundImage: `url("${ImgBg2}")` }}>

        <Header navTitle="About UWILD.com" navLink="/about" />

        </div>
      </div>

    </main>
  )
}

export default IndexPage
